export default "__VITE_ASSET__d96d11cd__"